import request from "@/utils/request";
//骑手分析
export function riderAnalysis(params) {
  return request({
    url: "delivery/data-analysis/rider-analysis",
    method: "get",
    params,
  });
}
export function getIndexInfo(params) {
  return request({
    url: "delivery/survey/index",
    method: "get",
    params,
  });
}
export function getRankList(params) {
  return request({
    url: "delivery/survey/ranking-list",
    method: "get",
    params,
  });
}
export function getOrderList(params) {
  return request({
    url: "delivery/survey/merchant-dispatch",
    method: "get",
    params,
  });
}
export function getOrderInfo(params) {
  return request({
    url: "delivery/data-analysis/order-statistic",
    method: "get",
    params,
  });
}
